// contexts/ProgressContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';

const ProgressContext = createContext(null);

export const useProgress = () => {
    const context = useContext(ProgressContext);
    if (!context) {
        throw new Error('useProgress must be used within a ProgressProvider');
    }
    return context;
};

export const ProgressProvider = ({ children }) => {
    const [progressState, setProgressState] = useState({
        isActive: false,
        progress: 0,
        totalSteps: 0,
        currentOperation: '',
        source: ''
    });

    const startProgress = useCallback((totalSteps, source) => {
        setProgressState({
            isActive: true,
            progress: 0,
            totalSteps,
            currentOperation: 'Starting...',
            source
        });
    }, []);

    const updateProgress = useCallback((current, total, operation) => {
        setProgressState(prev => ({
            ...prev,
            progress: current,
            totalSteps: total,
            currentOperation: operation
        }));
    }, []);

    const completeProgress = useCallback(() => {
        setProgressState(prev => ({
            ...prev,
            isActive: false,
            progress: prev.totalSteps,
            currentOperation: 'Complete'
        }));
    }, []);

    return (
        <ProgressContext.Provider value={{
            progressState,
            startProgress,
            updateProgress,
            completeProgress
        }}>
            {children}
        </ProgressContext.Provider>
    );
};